import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import { STATUS_NAME_LEN, STATUS_NAME_DA, WO_ASSIGNED_WORKER, WO_XI, WO_NHAM, WO_BONG, WO_QUAYKIM, WO_READY, WO_COMPLETED_CK } from '../constants';

class CardByLenDaStatus extends Component {
  constructor() {
    super();
    this.state = {
      count: 0,
      status: 0,
      allStatus: []
    };
  }

  componentDidMount() {
    WorkOrderDataService.countByLenDaStatus(`${this.props.info.status}`, `${this.props.info.statusName}`).then(data => {
      this.setState({
        status: this.props.info.status,
        count: data ? data : 0,
        errorCode: 0
      });
    });
  }

  viewDetails() {
    sessionStorage.removeItem('lendas.fromDate');
    if (!AuthenticationService.isWorker()) {
      return;
    }
    let selectedStatus = [
      { id: WO_READY, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_READY)},
      { id: WO_COMPLETED_CK, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_COMPLETED_CK)},
      { id: WO_XI, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_XI) },
      { id: WO_ASSIGNED_WORKER, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_ASSIGNED_WORKER) },
      { id: WO_NHAM, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_NHAM) },
      { id: WO_BONG, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_BONG) },
      { id: WO_QUAYKIM, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_QUAYKIM) },
    ]
    WorkOrderUtil.saveItem('lendas.selectedWoStatusList', JSON.stringify(selectedStatus));
    if (this.props.info.statusName === STATUS_NAME_LEN) {
      WorkOrderUtil.saveItem('lendas.lenStatus', this.state.status);
    } else if (this.props.info.statusName === STATUS_NAME_DA) {
      WorkOrderUtil.saveItem('lendas.daStatus', this.state.status);
    }
    this.props.history.push("/lendas?status=" + this.state.status);
  }

  render() {
    if (this.props.info === undefined) {
      return (<></>);
    }

    let statusDesc = '';
    if (this.props.info.lenDa > 0) {
      if (this.props.info.statusName === STATUS_NAME_LEN) {
        statusDesc = WorkOrderUtil.getLenStatusDescription(this.state.status);
      } else {
        statusDesc = WorkOrderUtil.getDaStatusDescription(this.state.status);
      }
    }

    return (
      <Card style={{ width: '18rem' }}>
        {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
        <Card.Body>
          <Card.Title> {this.props.title ? this.props.title : statusDesc}</Card.Title>
          <Card.Text>
            {this.state.count}
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{couterpart.translate('wo_goto_details')}</Button>
        </Card.Body>
      </Card>
    )
  }
}

export default withRouter(CardByLenDaStatus);